<template>
<div class="mTeacherList">
    <pull :pull="pull" :page="page" @getList="getList">
        <NoData v-if="!item.teacherlist.length"></NoData>
        <div class="teacherList" v-else>
            <div class="teacher" v-for="(obj) in item.teacherlist" :key="obj.teacherid" @click="gotoTeacherView(obj)">
                <div class="left">
                    <img class="teacherlogourl" v-lazy="obj.teacherlogourl" alt="">
                </div>
                <div class="right">
                    <div class="name">{{obj.teachername}}</div>
                    <div class="desc text-ellipse">{{obj.content}}包把HTTPS加密过程学的明明白白，一次性掌握HTTPS通信的所有核心算法，并从零实现RSA、Diffie-Hellman等核心算法！
                        【限时免费，扫码参与！】</div>
                </div>
            </div>
        </div>
    </pull>
</div>
</template>

<script>
import Pull from 'views/mobile/components/pull/pull'
import {getAllTeacherByHost} from 'api/api'
import {mapActions} from 'vuex'
import NoData from 'views/mobile/components/noData/noData'
export default {
    name: 'mTeacherList',
    props: ['item'],
    data() {
        return {
            param: {
                hostid: this.$route.query.hostid ? this.$route.query.hostid : '',
            },
            page: {
                page: 1,
                pagesize: 10,
                pageCount: 2,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
        }
    },
    activated() {
        if (this.refresh) {
            this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
        }
    },
    methods: {
        gotoTeacherView(obj) {
            this.$router.push({name: 'MTeacherView', query: {hostid: this.param.hostid, teacherid: obj.teacherid}})
            this.setRefresh(true)
        },
        getList() {
            this.setLoading(true)
            getAllTeacherByHost({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.item.teacherlist = data.data.teacherlist
                    } else {
                        this.item.teacherlist = this.item.teacherlist.concat(data.data.teacherlist)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Pull, NoData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mTeacherList {
    .teacherList{
        padding: 0 0.32rem;
        background: $c-white;
        .teacher{
            padding: 0.32rem 0;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            border-bottom: 0.01rem solid $line;
            .left{
                width: 1rem;
                min-width: 1rem;
                height: 1rem;
                margin-right: 0.2rem;
                .teacherlogourl{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .right{
                height: 1rem;
                padding: 0.1rem 0;
                box-sizing: border-box;
                flex-grow: 1;
                .name{
                    color: $c-black;
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                }
                .desc{
                    margin-top: 0.04rem;
                    font-size: 0.26rem;
                    line-height: 0.36rem;
                    color: $c-grey;
                    width: 5.66rem;
                }
            }
        }
    }
}
</style>